export default __webpack_public_path__ + "static/media/nft-5.6439a16e.gif";